import { useSelector } from 'react-redux';

/**
 *
 */
export const useItemSelector = <TProps, TResult>(props: TProps, fn: (state: any, props: TProps) => TResult): TResult =>
  useSelector((state) => fn(state, props));
